import Coming from "../components/Coming";
export default function ProductEngineering() {
    return(
            <>
                <input type="hidden" id="comingDate" value="2024/5/20"/>
                <Coming />
            </>
    );
}